
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corporate_privacy_policy",
      function () {
        return require("private-next-pages/corporate_privacy_policy/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corporate_privacy_policy"])
      });
    }
  